/* global CarouselSlider */

if (!customElements.get('product-card-image-slider')) {
  customElements.whenDefined('carousel-slider').then(() => {
    class ProductCardImageSlider extends CarouselSlider {
      constructor() {
        super();

        this.productCard = this.closest('product-card');

        this.productCard.addEventListener(
          'change',
          this.handleSwatchChange.bind(this)
        );
      }

      init() {
        this.querySelectorAll('.slider__item').forEach((slide) => {
          slide.removeAttribute('hidden');
          slide.removeAttribute('aria-current');
        });

        super.init();

        if (!this.slider) return;

        this.slides = Array.from(
          this.querySelectorAll('.slider__item')
        );

        this.slider.addEventListener(
          'scroll',
          this.scrollInProgress.bind(this)
        );

        this.slides[0]?.setAttribute('aria-current', 'true');

        this.slider.scrollTo({
          left: 0,
          behavior: 'auto'
        });

        requestAnimationFrame(() => {
          this.setButtonStates();
        });
      }

      handleSwatchChange(evt) {
        if (!evt.target.matches('.opt-btn')) return;

        const mediaId = evt.target.dataset.mediaId;

        if (mediaId) {
          this.goToMedia(mediaId);
        }
      }

      goToMedia(mediaId) {
        const targetSlide = this.querySelector(
          `.slider__item[data-media-id="${mediaId}"]`
        );

        if (!targetSlide) return;

        this.slides.forEach((slide) => {
          slide.removeAttribute('hidden');
          slide.removeAttribute('aria-current');
        });

        targetSlide.setAttribute('aria-current', 'true');

        this.slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'auto'
        });

        requestAnimationFrame(() => {
          this.setButtonStates();
        });
      }

      scrollInProgress() {
        this.slider
          .querySelector('[aria-current]')
          ?.removeAttribute('aria-current');
      }

      handleScroll() {
        super.handleScroll();

        this.slides.forEach((slide) => {
          slide.removeAttribute('aria-current');
        });

        this.slides[this.currentIndex]?.setAttribute(
          'aria-current',
          'true'
        );
      }
    }

    customElements.define(
      'product-card-image-slider',
      ProductCardImageSlider
    );
  });
}